__turbopack_context__.v({
  "aCell": "UUt0zW_aCell",
  "desktopOnly": "UUt0zW_desktopOnly",
  "divider": "UUt0zW_divider",
  "ma": "UUt0zW_ma",
  "mobileGap": "UUt0zW_mobileGap",
  "mobileItem": "UUt0zW_mobileItem",
  "mobileOnly": "UUt0zW_mobileOnly",
  "mq": "UUt0zW_mq",
  "qCell": "UUt0zW_qCell",
  "section": "UUt0zW_section",
  "table": "UUt0zW_table",
  "tableSpacer": "UUt0zW_tableSpacer",
  "title": "UUt0zW_title",
});
